import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '@/lib/orpc'
import { useCompleteQuickStart, useCompleteOwnerOnboarding } from '@/lib/hooks/onboarding'
import type { QuickStartStep } from './QuickStartGuideDrawer'

export type StepId = 'owner-details' | 'aircraft' | 'crew' | 'roster-entry' | 'passenger'

export function useQuickStartGuide(steps: QuickStartStep[]) {
  const [activeDrawer, setActiveDrawer] = useState<StepId | null>(null)
  const [showAllSetDialog, setShowAllSetDialog] = useState(false)
  const queryClient = useQueryClient()
  const orpc = useOrpcTanstackQueryUtils()
  const completeQuickStart = useCompleteQuickStart()
  const completeOwnerOnboarding = useCompleteOwnerOnboarding()

  const completedCount = steps.filter((s) => s.completed).length
  const totalCount = steps.length
  const allCompleted = completedCount === totalCount

  const crewCompleted = steps.find((s) => s.id === 'crew')?.completed ?? false

  const firstIncompleteId = steps.find(
    (s) => !s.completed && !(s.id === 'roster-entry' && !crewCompleted),
  )?.id

  const handleDrawerClose = (callback?: () => void) => {
    setActiveDrawer(null)
    queryClient.invalidateQueries({ queryKey: orpc.onboarding.key() })
    callback?.()
  }

  const handleFinish = (options?: { showDialog?: boolean }, callback?: () => void) => {
    completeQuickStart.mutate({})
    completeOwnerOnboarding.mutate({})
    if (options?.showDialog !== false) {
      setShowAllSetDialog(true)
    }
    callback?.()
  }

  return {
    activeDrawer,
    setActiveDrawer,
    showAllSetDialog,
    setShowAllSetDialog,
    completedCount,
    totalCount,
    allCompleted,
    crewCompleted,
    firstIncompleteId,
    handleDrawerClose,
    handleFinish,
  }
}
